import React, { createContext, useContext, useMemo, useState } from 'react';

interface FinishGateContextProps {
    canFinish: boolean;
    setCanFinish: (canFinish: boolean) => void;
}

const FinishGateContext = createContext<FinishGateContextProps | undefined>(undefined);

// 控制「结束对话（Finish）」按钮的可见性：
// 正式实验要求被试先选出图片，未完成选择前不展示 Finish。
export const FinishGateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [canFinish, setCanFinish] = useState(false);
    const value = useMemo(() => ({ canFinish, setCanFinish }), [canFinish]);

    return <FinishGateContext.Provider value={value}>{children}</FinishGateContext.Provider>;
};

const fallbackContext: FinishGateContextProps = {
    canFinish: true,
    setCanFinish: () => undefined,
};

// 未包在 Provider 内时返回安全默认值（允许结束），避免顶栏在其它页面渲染时报错
export const useFinishGate = (): FinishGateContextProps => {
    const context = useContext(FinishGateContext);
    return context || fallbackContext;
};
